<template>
  <div>
    <mu-avatar icon="battery_charging_full" backgroundColor="#2196f3" slot="leftAvatar" />
    <mu-badge :content="trainCounts" circle secondary>
      <span class="train-counts">训练次数</span>
    </mu-badge>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '../../../store/index.js'
  export default {
    store,
    mounted () {
      var self = this;
      self.getsurplusTrainCounts();
    },
    methods: {
      getsurplusTrainCounts(){
        var self = this;
        self.$store.commit('changeCounts');//修改训练次数
      }
    },
    computed:{
      trainCounts(){
        return this.$store.state.trainCounts;
      }
    }
  }
</script>

<style lang="css" scoped>
.train-counts{
  color:#fff;
  position:relative;
  top:-5px;
  left:0;
  margin-right:10px;
}
</style>



// WEBPACK FOOTER //
// allTrainTimes.vue?3f316ad8